var _style, _path, _g, _path2, _rect, _defs, _path3, _rect2, _path4, _defs2, _path5, _path6, _path7, _path8, _path9, _g2, _polygon, _path10, _defs3, _path11, _path12, _path13, _g3, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvantage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 663.2 716.3",
    style: {
      enableBackground: "new 0 0 663.2 716.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#35363B;stroke-miterlimit:10;stroke-dasharray:0,0,4,4;}\r\n\t.st1{fill:#222325;}\r\n\t.st2{fill:#4A4B4D;}\r\n\t.st3{opacity:0.2;enable-background:new    ;}\r\n\t.st4{fill:#5AE4A7;}\r\n\t.st5{clip-path:url(#SVGID_00000088840985777069739110000014285258001878160001_);}\r\n\t.st6{fill:none;stroke:#1A2E35;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_00000026850029105908036830000017057894960939652239_);}\r\n\t.st9{opacity:0.4;fill:#5AE4A7;enable-background:new    ;}\r\n\t.st10{fill:#1A2E35;}\r\n\t.st11{fill:#5AE4A7;stroke:#1A2E35;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st12{opacity:0.5;fill:#5AE4A7;enable-background:new    ;}\r\n\t.st13{fill:#757575;stroke:#1A2E35;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st14{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st15{clip-path:url(#SVGID_00000018950116260691561510000006380026473721824424_);}\r\n\t.st16{fill:#999999;stroke:#1A2E35;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st17{opacity:0.1;}\r\n\t.st18{opacity:0.6;fill:#5AE4A7;enable-background:new    ;}\r\n\t.st19{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st20{opacity:0.2;fill:#5AE4A7;enable-background:new    ;}\r\n\t.st21{opacity:0.39;fill:#008C6B;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_1-2_00000072982117056393718420000006543456781127858822_"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,77.1h516c14.1,0,25.5,11.4,25.5,25.5v435c0,14.1-11.4,25.5-25.5,25.5h-516c-14.1,0-25.5-11.4-25.5-25.5 v-435C22,88.6,33.4,77.1,47.5,77.1z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.7,43c-46.7,7.7-91.4,24.7-129.5,54c-55.3,42.6-86,106.4-89.2,175.7c-2.1,45.8,8.8,90.4,22,133.8 c17,55.9,27.9,119.6,63.4,167.4c55.2,74.4,161.9,105.7,251.1,92.4c57.6-8.6,118.6-41.3,136.3-100.5c6.6-21.9,9.8-45.5,21-65.7 c13.5-24.3,37.8-38.4,56.4-58.2c22.9-24.4,32.1-54.8,37.8-87c12.5-70.4-4.6-144.9-45.7-203.3C542.4,90.7,478.8,58,406.5,45.2 c-7.9-1.4-15.9-2.6-23.9-3.6C342.9,36.6,301.6,36.4,261.7,43L261.7,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.5,308.6c-21,59.6,18.1,133.6,69,172c49.1,37,116.4,46.4,169,27c64.7-23.9,61.8-74.7,146-116 c55.2-27.1,78.6-16.1,93-40c29.3-48.7-25.5-165.2-111-194c-43.6-14.7-94.3,5-194,45C176.9,244.5,124.3,266.4,109.5,308.6 L109.5,308.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.8,503.2L273,481.8c0,0,26.1,82.3,31.3,92.9l-2.8,6.5l1.7,10.8l-114.5,26l-9.2-7.2L157.8,503.2 L157.8,503.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.9,
    y: 484.6,
    transform: "matrix(0.9731 -0.2304 0.2304 0.9731 -118.8551 65.7687)",
    className: "st4",
    width: 114.5,
    height: 114.5
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 164.9,
    y: 484.6,
    transform: "matrix(0.9731 -0.2304 0.2304 0.9731 -118.8551 65.7687)",
    width: 114.5,
    height: 114.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014633315653933028770000003774391727219952821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014633315653933028770000003774391727219952821_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.8,503l18.5,78.1l-106.3,25.2c-12.8-32-22.6-72.4-22.6-72.4L271.8,503L271.8,503z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.9,
    y: 484.6,
    transform: "matrix(0.9731 -0.2304 0.2304 0.9731 -118.8551 65.7687)",
    className: "st6",
    width: 114.5,
    height: 114.5
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.6,577.3c-27.8,6.6-67.3,12.8-91.1,16.3c-12.4,1.8-20.6,2.9-20.6,2.9c-10.6-19.3-29.6-97.1-29.6-97.1 l111.4-26.4c0.2,1,0.4,1.9,0.6,2.8C278.6,536,294.6,577.3,294.6,577.3L294.6,577.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000153667066961644207160000011311679242070132867_",
    d: "M294.6,577.3c-27.8,6.6-67.3,12.8-91.1,16.3 c-12.4,1.8-20.6,2.9-20.6,2.9c-10.6-19.3-29.6-97.1-29.6-97.1l111.4-26.4c0.2,1,0.4,1.9,0.6,2.8 C278.6,536,294.6,577.3,294.6,577.3L294.6,577.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170998639874078307470000012934805283394638721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153667066961644207160000011311679242070132867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170998639874078307470000012934805283394638721_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M294.6,577.3c-27.8,6.6-67.3,12.8-91.1,16.3c-17.9-11.9-22.2-23.5-22-34.6c0.2-13.2,57.7-0.3,69.7-13.4 c8.6-9.3,8.3-48.9,14.1-69.8C278.6,536,294.6,577.3,294.6,577.3L294.6,577.3z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.6,577.3c-27.8,6.6-67.3,12.8-91.1,16.3c-12.4,1.8-20.6,2.9-20.6,2.9c-10.6-19.3-29.6-97.1-29.6-97.1 l111.4-26.4c0.2,1,0.4,1.9,0.6,2.8C278.6,536,294.6,577.3,294.6,577.3L294.6,577.3z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M172.1,516.2c1.5-1.8,3.3-3.2,5.4-4.4c0.6,1.4,1.1,2.8,1.7,4.2c1.9-0.7,3.9-1.4,5.8-2.1s4.1-1.6,4.8-3.5 c1.1,2.5,4.7,2.1,7.3,1.3c18-5.8,36.4-10.3,55.1-13.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M174.9,531.6c-1.2-0.6-0.2-2.8,1.1-2.7s2.2,1.6,2.3,2.9c1.2-0.1,2.2-1.1,2.4-2.2c0.6,0.4,1.3,0.9,1.9,1.3 c-0.7-0.9-0.3-2.4,0.7-3c1-0.6,2.4-0.1,2.9,0.9c-0.1-1.6,0.5-3.8,2-3.5c0.5,0.1,0.9,0.5,1.3,0.8c1.8,1.3,4.8,0.1,5.2-2.2 c1.5,1.7,4.2,1.5,6.4,1.1c6.7-1.1,13.4-2.3,20.1-3.4c0.2-1.3,0.8-2.9,2.1-2.7c0.7,0.1,1.2,0.8,1.9,1.2c0.9,0.5,2.1,0.3,3.1,0.1 c9-2,17.9-4.6,26.5-8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.8,549.2c2.7,0.2,5.4-0.1,7.9-1.1c-0.9-1.9-0.4-4.3,1.3-5.6c0.8,0.5,1.6,1,2.4,1.5 c9.7-0.2,19.5-1.6,28.9-4c4.2-1.1,8.4-2.4,12.6-3.7c7.9-2.5,15.8-4.9,23.8-7.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M479.9,94.1l-2.2,0.1c-2.2,0.1-4.1-1.1-4.6-3.1c-3.4-12.3-15.7-19.2-30.1-18.4c-12.9,0.8-26.5,9-34.4,20.2 c-2.1,3-5.4,5.1-8.7,5.3l-11,0.7c-3.3,0.2-6-1.5-7.2-4.3c-4.5-10.5-15.7-17.1-28.6-16.3c-14.3,0.9-29.1,9.5-36.5,22.5 c-1.2,2.2-3.5,3.6-5.7,3.8l-2.2,0.1c-1,0.1-2,0.9-2.1,2l-0.9,5.5c-0.1,0.8,0.3,1.6,1.1,1.7l2.7,0.8c2.1,0.6,3.4,2.5,3.3,4.9 c-0.9,17.6,11.5,30.6,29.2,29.5c17.1-1.1,33.4-14.8,38.7-31.9c0.9-2.8,3.3-5.1,6-5.7c3.2-0.8,7.3-1.4,11.6-0.8 c2.6,0.3,4.4,2.4,4.4,5.1c0,16.7,12.1,28.8,29.3,27.7c17.7-1.1,34.5-15.9,39.2-33.7c0.6-2.4,2.6-4.5,4.9-5.4l3-1.2 c0.8-0.3,1.5-1.1,1.6-1.9l0.9-5.5C481.6,94.8,480.9,94,479.9,94.1L479.9,94.1z M342.6,144.5c-16.5,1-27.7-11.9-25-28.9 c2.7-17,18.2-31.6,34.7-32.6c16.5-1,27.7,11.9,25,28.9C374.7,128.8,359.1,143.5,342.6,144.5z M382.2,108.3 c0.1-1,0.1-1.9,0.1-2.8c0-0.8,0.7-1.5,1.5-1.6l19.7-1.2c0.8-0.1,1.3,0.6,1,1.4c-0.3,0.9-0.6,1.9-0.8,2.9 C395.2,104.4,386.7,106.7,382.2,108.3L382.2,108.3z M432.6,138.9c-16.5,1-27.7-12-25-28.9c2.7-17,18.2-31.6,34.7-32.6 c16.5-1,27.7,11.9,25,28.9C464.6,123.3,449,137.9,432.6,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M465.8,97.5l-126.3,16.7c-6,0.8-11.5,4.1-14.9,9.1l-18.5,26.9c-0.7,1.1-0.3,2.5,0.9,3l0,0 c2.5,1,5.4,0.1,7-2.2l17.1-24.8c2.1-3,5.3-5,8.9-5.5l126.3-17.9L465.8,97.5L465.8,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.4,108.1l127.4-2.1c6.1-0.1,11.9,2.4,16.1,6.8l22.3,23.9c0.9,0.9,0.6,2.5-0.5,3.1l0,0 c-2.4,1.3-5.4,0.9-7.2-1.1l-20.6-22c-2.5-2.7-6-4.2-9.6-4.1l-127.5,1L295.4,108.1L295.4,108.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M372.6,116.2c1.6,0.3,1.5,11-2,14.6c-3.5,3.7-7.2-5.2-6.3-8.4C365.2,119.4,367.7,115.3,372.6,116.2 L372.6,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M394.7,114.9c-1.5,0.5-0.1,11.1,3.8,14.3c4,3.2,6.5-6,5.2-9.1S399.5,113.3,394.7,114.9L394.7,114.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M315.8,91.1c6.7-5.7,20.8-15.4,36.2-6.2s20.8,19.2,17.6,32.9c-3.2,13.6-12.9,31.8-35.8,28.6 C310.9,143.3,295.1,108.8,315.8,91.1L315.8,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M405.9,86.7c6.7-5.7,20.8-15.4,36.2-6.2s20.8,19.2,17.6,32.9s-12.9,31.8-35.8,28.6 C401,138.9,385.2,104.4,405.9,86.7L405.9,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M468.4,95.6l-2.2,0.1c-2.2,0.1-4.4-1-5.4-3c-6.1-11.9-20.2-18.7-34.5-17.8c-12.9,0.8-24.9,8.7-30.4,19.7 c-1.5,3-4.3,5-7.6,5.2l-11,0.7c-3.3,0.2-6.4-1.5-8.2-4.2c-6.8-10.2-19.7-16.6-32.6-15.8c-14.3,0.9-27.5,9.3-32.1,21.9 c-0.8,2.1-2.7,3.5-5,3.7l-2.2,0.1c-1,0.1-1.8,0.9-1.7,1.9l0.3,5.4c0,0.8,0.7,1.5,1.5,1.7l2.9,0.8c2.3,0.6,4,2.4,4.4,4.8 c2.9,17.1,18.4,29.7,36.1,28.6c17.1-1.1,30.5-14.5,32.2-31c0.3-2.7,2.2-4.9,4.8-5.6c3.1-0.8,7.1-1.4,11.6-0.8 c2.7,0.3,5,2.3,5.6,4.9c3.6,16.2,18.6,27.9,35.8,26.8c17.7-1.1,31.5-15.5,32.3-32.8c0.1-2.3,1.6-4.4,3.8-5.3l2.8-1.1 c0.8-0.3,1.3-1,1.2-1.8l-0.3-5.4C470.3,96.3,469.4,95.5,468.4,95.6L468.4,95.6z M340.3,144.8c-16.5,1-30.7-11.6-31.7-28 s11.5-30.7,28-31.7c16.5-1,30.7,11.6,31.7,28S356.8,143.7,340.3,144.8z M372.5,109.6c-0.1-0.9-0.3-1.9-0.5-2.8 c-0.2-0.8,0.4-1.5,1.1-1.5l19.7-1.2c0.8-0.1,1.4,0.6,1.3,1.4c-0.1,0.9-0.2,1.8-0.2,2.8C384.8,105.8,376.7,108,372.5,109.6 L372.5,109.6z M430.3,139.2c-16.5,1-30.7-11.6-31.7-28s11.5-30.7,28-31.7c16.5-1,30.7,11.6,31.7,28S446.7,138.2,430.3,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M318.2,134.2c0,0-11-14.6-3.2-31.5c7-15.2,23.4-17,31.2-13.7l-17,29.6c2.3-11,7-21,7-21 S321.3,112.7,318.2,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M408,127.7c0,0-11-14.6-3.2-31.5c7-15.2,23.4-17,31.2-13.7l-17,29.6c1.3-10.6,7-21,7-21 S411,106.2,408,127.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "85,385 89,403 93.6,382.7 81.6,179.8 73.4,179.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.7,177.3l11.3,204l-4.2,16.8l-6-16.2l-11.3-204c-0.1-1.4,1-2.6,2.4-2.7l5-0.3 C76.4,174.8,77.6,175.9,77.7,177.3L77.7,177.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142160612336554959310000009473451610918180253_",
    d: "M77.7,177.3l11.3,204l-4.2,16.8l-6-16.2l-11.3-204 c-0.1-1.4,1-2.6,2.4-2.7l5-0.3C76.4,174.8,77.6,175.9,77.7,177.3L77.7,177.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178194982906117341830000010583888623479609740_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142160612336554959310000009473451610918180253_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178194982906117341830000010583888623479609740_)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.8,398.2l-6-16.2l-11.3-204c-0.1-1.4,1-2.6,2.4-2.7l0.7,0l11.4,205.5L84.8,398.2z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.7,177.3l11.3,204l-4.2,16.8l-6-16.2l-11.3-204c-0.1-1.4,1-2.6,2.4-2.7l5-0.3 C76.4,174.8,77.6,175.9,77.7,177.3L77.7,177.3z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.9,178.7L82,379c0.1,1,0.9,1.7,1.8,1.6l1.2-0.1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121,423.1l37.3-243.9c2.4-15.6,17-26.3,32.6-23.9l358.4,54.9c15.6,2.4,26.3,17,24,32.6L536,486.6 c-2.4,15.6-17,26.3-32.6,24L145,455.7C129.4,453.3,118.6,438.7,121,423.1L121,423.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M149.7,188.7l2.9-19.3c0.1-0.5,0.6-0.9,1.1-0.8l8.2,1.3l-3.2,21.2l-8.2-1.3 C150,189.8,149.6,189.3,149.7,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M197.9,149.3l19.3,2.9c0.5,0.1,0.9,0.6,0.8,1.1l-1.3,8.2l-21.2-3.2l1.3-8.2 C196.9,149.6,197.4,149.2,197.9,149.3L197.9,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M223.2,153.1l19.3,2.9c0.5,0.1,0.9,0.6,0.8,1.1l-1.3,8.2l-21.2-3.2l1.3-8.2 C222.1,153.4,222.6,153.1,223.2,153.1L223.2,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M116.9,417.6l37.3-243.9c2.4-15.6,17-26.3,32.6-23.9l358.4,54.9c15.6,2.4,26.3,17,23.9,32.6l-37.3,243.9 c-2.4,15.6-17,26.3-32.6,24l-358.4-54.9C125.2,447.8,114.5,433.2,116.9,417.6L116.9,417.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M500.7,502l-360.3-55.1c-13.4-2-22.5-14.5-20.5-27.9l37.6-245.7c2-13.4,14.5-22.5,27.9-20.5l360.3,55.1 c13.4,2,22.5,14.5,20.5,27.9l-37.6,245.7C526.5,494.9,514,504,500.7,502z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M144.8,297c-0.1,0.8-0.8,1.3-1.6,1.2s-1.3-0.8-1.2-1.6c0.1-0.8,0.8-1.3,1.6-1.2 C144.4,295.5,144.9,296.2,144.8,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.1,309.8c-0.2,1.5-1.6,2.5-3.1,2.2c-1.5-0.2-2.5-1.6-2.2-3.1c0.2-1.5,1.6-2.5,3.1-2.2 S144.3,308.4,144.1,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.8,279c-0.2,1.5-1.6,2.5-3.1,2.2c-1.5-0.2-2.5-1.6-2.2-3.1c0.2-1.5,1.6-2.5,3.1-2.2 C148,276.1,149,277.5,148.8,279z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142,318.5c-0.2,1.1-1.2,1.8-2.2,1.6c-1.1-0.2-1.8-1.2-1.6-2.2s1.2-1.8,2.2-1.6 C141.5,316.4,142.2,317.4,142,318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.1,231.5l-38.5,251.3c-1,6.6-7.2,11.1-13.8,10.1l-301.8-46.2l-6.5-1l-24.6-3.8l-11.9-1.8l-17.2-2.6 L139,437c-6.6-1-11.1-7.2-10.1-13.8l38.5-251.3c1-6.6,7.2-11.1,13.8-10.1L293.8,179l17,2.6l16.3,2.5l20.9,3.2l7.6,1.2 L547,217.8C553.6,218.8,558.1,224.9,557.1,231.5L557.1,231.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.2,444.4l-128-19.6c-1.7-0.3-2.9-1.9-2.7-3.6l12.7-83.1c0.3-1.7,1.9-2.9,3.6-2.7l128,19.6 c1.7,0.3,2.9,1.9,2.7,3.6l-12.7,83.1C277.6,443.5,275.9,444.7,274.2,444.4L274.2,444.4z M159.7,336.6 c-1.1-0.2-2.2,0.6-2.4,1.7l-12.7,83.1c-0.2,1.1,0.6,2.2,1.7,2.4l128,19.6c1.1,0.2,2.2-0.6,2.4-1.7l12.7-83.1 c0.2-1.1-0.6-2.2-1.7-2.4L159.7,336.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M198.3,386.9l28.7,16.3c1.8-3.4,3.1-7.1,3.7-11.1c1.4-9-0.9-17.8-5.9-24.7L198.3,386.9L198.3,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M198.6,385.3l25.6-18.8c-3.4-4.5-7.9-8.1-13.3-10.5l-5.1,12L198.6,385.3L198.6,385.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203,353.6l-4.4,29l11.4-27C207.7,354.7,205.4,354,203,353.6L203,353.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M196.8,386.6l5.1-33.1c-18.2-2.5-35.2,10.1-38,28.4c-0.9,6-0.2,11.8,1.8,17L196.8,386.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M192.2,420.4c14.1,2.1,27.4-4.7,34.2-16.3l-29.2-16.5l-31.2,12.3C170.4,410.5,180.1,418.5,192.2,420.4 L192.2,420.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.4,366.4l4.3,0.7c0.3,0.1,0.6,0.4,0.5,0.7l-0.7,4.3c-0.1,0.3-0.4,0.6-0.7,0.5l-4.3-0.7 c-0.3-0.1-0.6-0.4-0.5-0.7l0.7-4.3C245.8,366.6,246.1,366.3,246.4,366.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M271.1,372.2l-16.6-2.5c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l16.6,2.5c0.4,0,0.6,0.4,0.5,0.7 C271.8,372,271.4,372.3,271.1,372.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.6,374.2l-11.5-1.8c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l11.5,1.8c0.4,0,0.6,0.4,0.5,0.7 S265.9,374.3,265.6,374.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M244.5,378.7l4.3,0.7c0.3,0.1,0.6,0.4,0.5,0.7l-0.7,4.3c-0.1,0.3-0.4,0.6-0.7,0.5l-4.3-0.7 c-0.3-0.1-0.6-0.4-0.5-0.7l0.7-4.3C243.9,378.9,244.2,378.7,244.5,378.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269.2,384.6l-16.6-2.5c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l16.6,2.5c0.4,0,0.6,0.4,0.5,0.7 C269.9,384.4,269.5,384.6,269.2,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.7,386.6l-11.5-1.8c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l11.5,1.8c0.4,0,0.6,0.4,0.5,0.7 C264.4,386.4,264.1,386.6,263.7,386.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M242.6,391.1l4.3,0.7c0.3,0.1,0.6,0.4,0.5,0.7l-0.7,4.3c-0.1,0.3-0.4,0.6-0.7,0.5l-4.3-0.7 c-0.3-0.1-0.6-0.4-0.5-0.7l0.7-4.3C242,391.3,242.3,391,242.6,391.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.3,396.9l-16.6-2.5c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l16.6,2.5c0.3,0,0.6,0.4,0.5,0.7 S267.7,397,267.3,396.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M261.8,398.9l-11.5-1.8c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l11.5,1.8c0.4,0,0.6,0.4,0.5,0.7 C262.5,398.7,262.2,398.9,261.8,398.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M240.8,403.4l4.3,0.7c0.3,0.1,0.6,0.4,0.5,0.7l-0.7,4.3c-0.1,0.3-0.4,0.6-0.7,0.5l-4.3-0.7 c-0.3-0.1-0.6-0.4-0.5-0.7l0.7-4.3C240.1,403.6,240.4,403.4,240.8,403.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.4,409.2l-16.6-2.5c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l16.6,2.5c0.4,0,0.6,0.4,0.5,0.7 C266.1,409.1,265.8,409.3,265.4,409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.9,411.2l-11.5-1.8c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l11.5,1.8c0.3,0,0.6,0.4,0.5,0.7 S260.3,411.3,259.9,411.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M238.9,415.7l4.3,0.7c0.3,0.1,0.6,0.4,0.5,0.7l-0.7,4.3c-0.1,0.3-0.4,0.6-0.7,0.5l-4.3-0.7 c-0.3-0.1-0.6-0.4-0.5-0.7l0.7-4.3C238.2,415.9,238.5,415.7,238.9,415.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.5,421.6l-16.6-2.5c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l16.6,2.5c0.4,0,0.6,0.4,0.5,0.7 S263.9,421.6,263.5,421.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M258,423.6l-11.5-1.8c-0.4,0-0.6-0.4-0.5-0.7s0.4-0.6,0.7-0.5l11.5,1.8c0.4,0,0.6,0.4,0.5,0.7 C258.7,423.4,258.4,423.6,258,423.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M515.4,389.9l-208.1-31.9c-1.7-0.3-3.4,0.9-3.6,2.7l-0.9,5.7l-0.2,1.1l-1.2,7.7l-0.2,1.1l-1.2,7.7 l-0.2,1.1l-1.2,7.7l-0.2,1.1l-1.2,7.7l-0.2,1.1l-1.2,7.7l-0.2,1.1l-1.2,7.7l-0.2,1.1l-1.2,7.7l-0.2,1.1L292,437l-0.2,1.1 l-0.9,5.7c-0.3,1.7,0.9,3.4,2.7,3.6l208.1,31.9c1.7,0.3,3.4-0.9,3.6-2.7l0.9-5.7l0.2-1.1l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1 l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1l1.2-7.7l0.2-1.1l0.9-5.7 C518.3,391.8,517.1,390.2,515.4,389.9z M504.2,476.4c-0.2,1.1-1.2,1.9-2.4,1.7l-208.1-31.9c-1.1-0.2-1.9-1.2-1.7-2.4l0.9-5.7 l212.2,32.5L504.2,476.4L504.2,476.4z M505.2,469.6l-212.2-32.5l1.2-7.7l212.2,32.5L505.2,469.6L505.2,469.6z M506.6,460.8 l-212.2-32.5l1.2-7.7l212.2,32.5L506.6,460.8z M507.9,452l-212.2-32.5l1.2-7.7l212.2,32.5L507.9,452L507.9,452z M509.3,443.2 l-212.2-32.5l1.2-7.7l212.2,32.5L509.3,443.2z M510.6,434.4l-212.2-32.5l1.2-7.7l212.2,32.5L510.6,434.4L510.6,434.4z  M512,425.5l-212.2-32.5l1.2-7.7l212.2,32.5L512,425.5z M513.3,416.7l-212.2-32.5l1.2-7.7L514.5,409L513.3,416.7L513.3,416.7 z M514.7,407.9l-212.2-32.5l1.2-7.7l212.2,32.5L514.7,407.9z M303.9,366.6l0.9-5.7c0.2-1.1,1.2-1.9,2.4-1.7L515.2,391 c1.1,0.2,1.9,1.2,1.7,2.4l-0.9,5.7L303.9,366.6L303.9,366.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M537.6,241.7L183,187.4c-2-0.3-3.8,1.1-4.1,3L159,320.2c-0.3,2,1.1,3.8,3,4.1l354.6,54.3 c2,0.3,3.8-1.1,4.1-3l19.9-129.8C540.9,243.8,539.6,242,537.6,241.7L537.6,241.7z M248.4,260.3l24.7,3.8l-2.1,14l-24.7-3.8 L248.4,260.3L248.4,260.3z M245.2,274.2l-24.7-3.8l2.1-14l24.7,3.8L245.2,274.2L245.2,274.2z M274.2,264.3l24.7,3.8l-2.1,14 l-24.7-3.8L274.2,264.3L274.2,264.3z M402,282.7l-24.7-3.8l2.1-14l24.7,3.8L402,282.7z M405.3,268.9l24.7,3.8l-2.1,14 l-24.7-3.8L405.3,268.9z M325.7,272.2l24.7,3.8l-2.1,14l-24.7-3.8L325.7,272.2L325.7,272.2z M322.4,286l-24.7-3.8l2.1-14 l24.7,3.8L322.4,286L322.4,286z M351.4,276.1l24.7,3.8l-2.1,14l-24.7-3.8L351.4,276.1L351.4,276.1z M377.2,280l24.7,3.8 l-2.1,14l-24.7-3.8L377.2,280z M376.3,278.8l-24.7-3.8l2.1-14l24.7,3.8L376.3,278.8L376.3,278.8z M350.5,274.8l-24.7-3.8 l2.1-14l24.7,3.8L350.5,274.8L350.5,274.8z M324.7,270.9l-24.7-3.8l2.1-14l24.7,3.8L324.7,270.9L324.7,270.9z M299,267 l-24.7-3.8l2.1-14l24.7,3.8L299,267L299,267z M296.5,283.1l-2.1,14l-24.7-3.8l2.1-14L296.5,283.1L296.5,283.1z M297.6,283.3 l24.7,3.8l-2.1,14l-24.7-3.8L297.6,283.3L297.6,283.3z M323.4,287.3L348,291l-2.1,14l-24.7-3.8L323.4,287.3L323.4,287.3z  M349.1,291.2l24.7,3.8l-2.1,14l-24.7-3.8L349.1,291.2L349.1,291.2z M374.9,295.1l24.7,3.8l-2.1,14l-24.7-3.8L374.9,295.1z  M400.6,299.1l24.7,3.8l-2.1,14l-24.7-3.8L400.6,299.1z M400.8,298l2.1-14l24.7,3.8l-2.1,14L400.8,298L400.8,298z  M428.7,287.9l24.7,3.8l-2.1,14l-24.7-3.8L428.7,287.9z M454.5,291.9l24.7,3.8l-2.1,14l-24.7-3.8L454.5,291.9z M454.6,290.8 l2.1-14l24.7,3.8l-2.1,14L454.6,290.8L454.6,290.8z M453.5,290.6l-24.7-3.8l2.1-14l24.7,3.8L453.5,290.6z M431.2,271.7 l2.1-14l24.7,3.8l-2.1,14L431.2,271.7z M430.1,271.5l-24.7-3.8l2.1-14l24.7,3.8L430.1,271.5z M404.3,267.6l-24.7-3.8l2.1-14 l24.7,3.8L404.3,267.6z M378.6,263.7l-24.7-3.8l2.1-14l24.7,3.8L378.6,263.7L378.6,263.7z M352.8,259.7l-24.7-3.8l2.1-14 l24.7,3.8L352.8,259.7z M327.1,255.8l-24.7-3.8l2.1-14l24.7,3.8L327.1,255.8L327.1,255.8z M301.3,251.8l-24.7-3.8l2.1-14 l24.7,3.8L301.3,251.8z M275.5,247.9l-24.7-3.8l2.1-14l24.7,3.8L275.5,247.9L275.5,247.9z M275.4,249l-2.1,14l-24.7-3.8 l2.1-14L275.4,249L275.4,249z M247.5,259.1l-24.7-3.8l2.1-14l24.7,3.8L247.5,259.1L247.5,259.1z M221.7,255.1l-24.7-3.8 l2.1-14l24.7,3.8L221.7,255.1L221.7,255.1z M221.5,256.2l-2.1,14l-24.7-3.8l2.1-14L221.5,256.2L221.5,256.2z M219.2,271.3 l-2.1,14l-24.7-3.8l2.1-14L219.2,271.3L219.2,271.3z M220.3,271.5l24.7,3.8l-2.1,14l-24.7-3.8L220.3,271.5L220.3,271.5z  M246.1,275.4l24.7,3.8l-2.1,14l-24.7-3.8L246.1,275.4L246.1,275.4z M268.4,294.3l-2.1,14l-24.7-3.8l2.1-14L268.4,294.3 L268.4,294.3z M269.5,294.5l24.7,3.8l-2.1,14l-24.7-3.8L269.5,294.5L269.5,294.5z M295.3,298.4l24.7,3.8l-2.1,14l-24.7-3.8 L295.3,298.4L295.3,298.4z M321.1,302.4l24.7,3.8l-2.1,14l-24.7-3.8L321.1,302.4L321.1,302.4z M346.8,306.3l24.7,3.8 l-2.1,14l-24.7-3.8L346.8,306.3L346.8,306.3z M372.6,310.2l24.7,3.8l-2.1,14l-24.7-3.8L372.6,310.2z M398.3,314.2l24.7,3.8 l-2.1,14l-24.7-3.8L398.3,314.2z M424.1,318.1l24.7,3.8l-2.1,14l-24.7-3.8L424.1,318.1z M424.3,317l2.1-14l24.7,3.8l-2.1,14 L424.3,317z M452.2,307l24.7,3.8l-2.1,14L450,321L452.2,307z M477.9,310.9l24.7,3.8l-2.1,14l-24.7-3.8L477.9,310.9z  M478.1,309.8l2.1-14l24.7,3.8l-2.1,14L478.1,309.8z M480.4,294.7l2.1-14l24.7,3.8l-2.1,14L480.4,294.7z M482.7,279.6 l2.1-14l24.7,3.8l-2.1,14L482.7,279.6z M481.6,279.4l-24.7-3.8l2.1-14l24.7,3.8L481.6,279.4z M459.3,260.6l2.1-14l24.7,3.8 l-2.1,14L459.3,260.6z M458.2,260.4l-24.7-3.8l2.1-14l24.7,3.8L458.2,260.4z M432.4,256.4l-24.7-3.8l2.1-14l24.7,3.8 L432.4,256.4z M406.6,252.5l-24.7-3.8l2.1-14l24.7,3.8L406.6,252.5z M380.9,248.6l-24.7-3.8l2.1-14l24.7,3.8L380.9,248.6z  M355.1,244.6l-24.7-3.8l2.1-14l24.7,3.8L355.1,244.6L355.1,244.6z M329.4,240.7l-24.7-3.8l2.1-14l24.7,3.8L329.4,240.7 L329.4,240.7z M303.6,236.7l-24.7-3.8l2.1-14l24.7,3.8L303.6,236.7z M277.8,232.8l-24.7-3.8l2.1-14l24.7,3.8L277.8,232.8 L277.8,232.8z M252.1,228.9l-24.7-3.8l2.1-14l24.7,3.8L252.1,228.9L252.1,228.9z M251.9,230l-2.1,14l-24.7-3.8l2.1-14 L251.9,230z M224,240l-24.7-3.8l2.1-14l24.7,3.8L224,240L224,240z M198.3,236.1l-24.7-3.8l2.1-14l24.7,3.8L198.3,236.1 L198.3,236.1z M198.1,237.2l-2.1,14l-24.7-3.8l2.1-14L198.1,237.2L198.1,237.2z M195.8,252.3l-2.1,14l-24.7-3.8l2.1-14 L195.8,252.3L195.8,252.3z M193.5,267.4l-2.1,14l-24.7-3.8l2.1-14L193.5,267.4L193.5,267.4z M191.2,282.5l-2.1,14l-24.7-3.8 l2.1-14L191.2,282.5L191.2,282.5z M192.3,282.7l24.7,3.8l-2.1,14l-24.7-3.8L192.3,282.7L192.3,282.7z M218,286.6l24.7,3.8 l-2.1,14l-24.7-3.8L218,286.6L218,286.6z M240.4,305.5l-2.1,14l-24.7-3.8l2.1-14L240.4,305.5L240.4,305.5z M241.5,305.6 l24.7,3.8l-2.1,14l-24.7-3.8L241.5,305.6L241.5,305.6z M267.2,309.6l24.7,3.8l-2.1,14l-24.7-3.8L267.2,309.6L267.2,309.6z  M293,313.5l24.7,3.8l-2.1,14l-24.7-3.8L293,313.5L293,313.5z M318.7,317.5l24.7,3.8l-2.1,14l-24.7-3.8L318.7,317.5 L318.7,317.5z M344.5,321.4l24.7,3.8l-2.1,14l-24.7-3.8L344.5,321.4L344.5,321.4z M370.3,325.3l24.7,3.8l-2.1,14l-24.7-3.8 L370.3,325.3z M396,329.3l24.7,3.8l-2.1,14l-24.7-3.8L396,329.3z M421.8,333.2l24.7,3.8l-2.1,14l-24.7-3.8L421.8,333.2z  M447.5,337.2l24.7,3.8l-2.1,14l-24.7-3.8L447.5,337.2z M447.7,336.1l2.1-14l24.7,3.8l-2.1,14L447.7,336.1z M475.6,326 l24.7,3.8l-2.1,14l-24.7-3.8L475.6,326z M501.4,329.9l24.7,3.8l-2.1,14l-24.7-3.8L501.4,329.9z M501.5,328.8l2.1-14 l24.7,3.8l-2.1,14L501.5,328.8z M503.9,313.7l2.1-14l24.7,3.8l-2.1,14L503.9,313.7z M506.2,298.6l2.1-14l24.7,3.8l-2.1,14 L506.2,298.6z M508.5,283.5l2.1-14l24.7,3.8l-2.1,14L508.5,283.5L508.5,283.5z M510.8,268.4l2.1-14l24.7,3.8l-2.1,14 L510.8,268.4L510.8,268.4z M509.7,268.3l-24.7-3.8l2.1-14l24.7,3.8L509.7,268.3z M487.3,249.4l2.1-14l24.7,3.8l-2.1,14 L487.3,249.4z M486.2,249.2l-24.7-3.8l2.1-14l24.7,3.8L486.2,249.2z M460.5,245.3l-24.7-3.8l2.1-14l24.7,3.8L460.5,245.3z  M434.7,241.3l-24.7-3.8l2.1-14l24.7,3.8L434.7,241.3z M409,237.4l-24.7-3.8l2.1-14l24.7,3.8L409,237.4z M383.2,233.5 l-24.7-3.8l2.1-14l24.7,3.8L383.2,233.5L383.2,233.5z M357.4,229.5l-24.7-3.8l2.1-14l24.7,3.8L357.4,229.5L357.4,229.5z  M331.7,225.6l-24.7-3.8l2.1-14l24.7,3.8L331.7,225.6L331.7,225.6z M305.9,221.6l-24.7-3.8l2.1-14l24.7,3.8L305.9,221.6z  M280.2,217.7l-24.7-3.8l2.1-14l24.7,3.8L280.2,217.7L280.2,217.7z M254.4,213.8l-24.7-3.8l2.1-14l24.7,3.8L254.4,213.8 L254.4,213.8z M228.6,209.8L204,206l2.1-14l24.7,3.8L228.6,209.8L228.6,209.8z M228.5,210.9l-2.1,14l-24.7-3.8l2.1-14 L228.5,210.9L228.5,210.9z M200.6,221l-24.7-3.8l2.1-14l24.7,3.8L200.6,221L200.6,221z M164.2,293.8l24.7,3.8l-2.1,14 l-24.7-3.8L164.2,293.8L164.2,293.8z M189.9,297.7l24.7,3.8l-2.1,14l-24.7-3.8L189.9,297.7L189.9,297.7z M212.3,316.6 l-2.1,14l-24.7-3.8l2.1-14L212.3,316.6L212.3,316.6z M213.4,316.8l24.7,3.8l-2.1,14l-24.7-3.8L213.4,316.8L213.4,316.8z  M239.1,320.7l24.7,3.8l-2.1,14l-24.7-3.8L239.1,320.7L239.1,320.7z M264.9,324.7l24.7,3.8l-2.1,14l-24.7-3.8L264.9,324.7 L264.9,324.7z M290.7,328.6l24.7,3.8l-2.1,14l-24.7-3.8L290.7,328.6L290.7,328.6z M316.4,332.5l24.7,3.8l-2.1,14l-24.7-3.8 L316.4,332.5L316.4,332.5z M342.2,336.5l24.7,3.8l-2.1,14l-24.7-3.8L342.2,336.5z M367.9,340.4l24.7,3.8l-2.1,14l-24.7-3.8 L367.9,340.4z M393.7,344.4l24.7,3.8l-2.1,14l-24.7-3.8L393.7,344.4z M419.5,348.3l24.7,3.8l-2.1,14l-24.7-3.8L419.5,348.3z  M445.2,352.2l24.7,3.8l-2.1,14l-24.7-3.8L445.2,352.2z M471,356.2l24.7,3.8l-2.1,14l-24.7-3.8L471,356.2z M471.2,355.1 l2.1-14l24.7,3.8l-2.1,14L471.2,355.1z M499.1,345l24.7,3.8l-2.1,14l-24.7-3.8L499.1,345z M539.5,245.6l-1.8,11.5l-24.7-3.8 l2.1-14l22.2,3.4C538.8,242.9,539.7,244.2,539.5,245.6L539.5,245.6z M182.8,188.5l22.2,3.4l-2.1,14l-24.7-3.8l1.8-11.5 C180.2,189.2,181.5,188.2,182.8,188.5L182.8,188.5z M160.1,320.4l1.8-11.5l24.7,3.8l-2.1,14l-22.2-3.4 C160.8,323,159.9,321.7,160.1,320.4L160.1,320.4z M516.8,377.5l-22.2-3.4l2.1-14l24.7,3.8l-1.8,11.5 C519.4,376.8,518.1,377.7,516.8,377.5L516.8,377.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M525.9,334.8l-6.2,40.6c-0.2,1.3-1.4,2.2-2.8,2l-354.8-54.3c-1.3-0.2-2.2-1.4-2-2.8l0.8-5.4 c0,0,16.7-13.4,27.1-11.8c12.3,1.9,14.5,8.9,25.5,10.6c11,1.7,23.1-23.8,33-22.3c5.4,0.8,6.8,5,9.4,8.8 c2,2.8,4.6,5.5,10.2,6.4c0.1,0,0.3,0,0.4,0.1c13.5,2.1,31.8-69.6,50.3-66.7c8.2,1.3,11.5,17.1,14,34.5 c3.1,22.1,4.9,46.8,13.5,48.1c15.4,2.4,20.6-28.9,34.9-26.7c9,1.4,12.3,18,19.8,31.2c4.5,7.8,10.5,14.4,20.1,15.9 c8.7,1.3,14.5-0.7,19.1-3.9c8.9-6.2,12.9-16.8,24-15.1c6.6,1,9,6.1,11.4,10.9c2.1,4.2,4.3,8.1,9.4,8.9 c6,0.9,11-7.6,16.4-15.2c4.4-6.2,9-11.8,14.5-11c5.6,0.9,8.9,7.6,10.6,12.4C525.4,332.7,525.8,334.8,525.9,334.8 L525.9,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M534.4,279.1l-14.8,96.4c-0.2,1.3-1.4,2.2-2.8,2l-354.8-54.3c-1.3-0.2-2.2-1.4-2-2.8l0.8-5.4 c14.7,2.3,22.6-8.8,32.5-7.3c9.9,1.5,15,8.4,24.3,9.8c9.3,1.4,23.5-20.2,33.6-18.7c1.7,0.3,3.3,0.7,4.6,1.3 c3.9,1.6,6.6,4.2,10.2,6.4c2.4,1.5,5.3,2.7,9.3,3.3c11.9,1.8,35.6-41.1,49.3-39c2.4,0.4,4.4,1.6,6.1,3.5 c8.1,8.9,10.2,31,21.7,32.8c13.9,2.1,21.3-20.5,34.8-18.4s17.5,25.3,33.1,27.7c15.6,2.4,32.5-40.2,48.7-37.8 c16.2,2.5,20.8,24.4,34.9,26.5C519.5,307.6,534.4,279.1,534.4,279.1L534.4,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M527.5,323.9l-7.9,51.6c-0.2,1.3-1.4,2.2-2.8,2l-354.8-54.3c-1.3-0.2-2.2-1.4-2-2.8l0.4-2.6 c0.5-0.5,8.9-8.4,17.4-7.1c8.8,1.3,8.8,9.2,21,11.1c12.2,1.9,15.8-7.8,33.1-5.1c17.4,2.7,17.3,14.8,35.2,17.5 c17.9,2.8,21.6-11.8,34.4-9.8c12.7,2,11.9,9.4,19.1,10.5c7.2,1.1,11.5-10.2,20.4-8.9s15.7,20,25.8,21.6 c7,1.1,19.5-12.9,32.2-20.4c5.4-3.2,10.8-5.2,15.9-4.4c10.5,1.6,16.6,9.8,23.2,16.4c4.2,4.2,8.6,7.7,14.4,8.6 c8.3,1.3,14.6-6.2,21-12.9c5.2-5.4,10.4-10.2,16.8-9.2c4,0.6,6.9,1.7,9,2.9c5.5,3.1,7,7.2,13.6,8.2 C520.9,338,527.6,323.9,527.5,323.9L527.5,323.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204,183.2l-19.1-2.9c-1.9-0.3-3.1-2-2.8-3.9l0,0c0.3-1.9,2-3.1,3.9-2.8l19.1,2.9c1.9,0.3,3.1,2,2.8,3.9 l0,0C207.6,182.2,205.9,183.5,204,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M214.6,179L214.6,179c0.1,0,0.2,0,0.4,0l19.1,2.9c1.3,0.2,2.2,1.4,2,2.7c-0.2,1.2-1.2,2-2.4,2 c-0.1,0-0.2,0-0.4,0l-19.1-2.9c-0.6-0.1-1.2-0.4-1.6-0.9s-0.5-1.1-0.4-1.8C212.4,179.9,213.4,179,214.6,179 M214.6,178 c-1.6,0-3.1,1.2-3.4,2.9c-0.3,1.9,1,3.6,2.8,3.9l19.1,2.9c0.2,0,0.4,0,0.5,0c1.6,0,3.1-1.2,3.4-2.9c0.3-1.9-1-3.6-2.8-3.9 l-19.1-2.9C214.9,178,214.7,178,214.6,178L214.6,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.6,183.4L243.6,183.4c0.1,0,0.2,0,0.4,0l19,2.9c0.6,0.1,1.2,0.4,1.6,0.9s0.5,1.1,0.4,1.8 c-0.2,1.2-1.2,2-2.4,2c-0.1,0-0.2,0-0.4,0l-19.1-2.9c-0.6-0.1-1.2-0.4-1.6-0.9s-0.5-1.1-0.4-1.8 C241.4,184.3,242.4,183.4,243.6,183.4 M243.6,182.4c-1.6,0-3.1,1.2-3.4,2.9c-0.3,1.9,1,3.6,2.8,3.9l19,2.9c0.2,0,0.4,0,0.5,0 c1.6,0,3.1-1.2,3.4-2.9c0.3-1.9-1-3.6-2.8-3.9l-19.1-2.9C244,182.5,243.8,182.4,243.6,182.4L243.6,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M540.3,231.6l0.2-1.5l-1.1-0.3c0-0.2-0.1-0.5-0.2-0.7l0.8-0.7l-0.9-1.2l-1,0.6c-0.2-0.1-0.4-0.3-0.6-0.4 l0.1-1.1l-1.5-0.2l-0.3,1.1c-0.2,0-0.5,0.1-0.7,0.2l-0.7-0.9l-1.2,0.9l0.6,1c-0.2,0.2-0.3,0.4-0.4,0.6l-1.1-0.1l-0.2,1.5 l1.1,0.3c0,0.2,0.1,0.5,0.2,0.7l-0.8,0.7l0.9,1.2l1-0.6c0.2,0.1,0.4,0.3,0.6,0.4l-0.1,1.1l1.5,0.2l0.3-1.1 c0.2,0,0.5-0.1,0.7-0.2l0.7,0.9l1.2-0.9l-0.6-1c0.2-0.2,0.3-0.4,0.4-0.6L540.3,231.6z M536,232c-0.9-0.1-1.6-1-1.5-2 c0.1-1,1-1.6,2-1.5c0.9,0.1,1.6,1,1.5,2C537.9,231.5,537,232.1,536,232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.1,
    y: 407.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -131.798 665.8935)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.4,
    y: 404.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -128.0918 663.5807)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296.9,
    y: 413.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -146.3751 660.8214)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.7,
    y: 413.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -146.3591 660.7758)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.6,
    y: 406.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -146.4862 646.7338)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.9,
    y: 409.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -150.1277 649.0064)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.4,
    y: 414.8,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -131.8731 680.1143)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.7,
    y: 411.5,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -128.1386 677.7944)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 325.8,
    y: 407.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -115.8745 684.2917)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.3,
    y: 403.2,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -110.9381 681.2054)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 416.5,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -117.9269 699.7244)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.6,
    y: 409.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -110.5292 695.1209)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.2,
    y: 402.7,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -94.5389 699.3057)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 396,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -87.1412 694.7022)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 351.5,
    y: 422.4,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -108.6923 722.2964)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 419.1,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -104.986 719.9836)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.4,
    y: 425.5,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -104.2309 733.6816)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.7,
    y: 428.7,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -107.8724 735.9542)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.3,
    y: 408.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -77.4018 731.1429)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 413,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -82.2987 734.1766)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.5,
    y: 422.8,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -85.3882 750.2607)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.6,
    y: 420.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -82.8896 748.705)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 389.8,
    y: 416.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -70.5202 755.1498)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.1,
    y: 413.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -66.8055 752.8469)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.9,
    y: 404.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -49.544 756.2328)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.9,
    y: 397.2,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -40.9162 750.8557)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.2,
    y: 424.7,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -63.7864 779.2916)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.6,
    y: 420.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -58.8615 776.2148)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.3,
    y: 439,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -71.7643 798.4193)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.8,
    y: 434.5,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -66.821 795.3439)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 425.8,
    y: 424.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -48.1611 797.8646)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.1,
    y: 428.2,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -51.7941 800.147)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 437.4,
    y: 409.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -23.393 796.5792)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.4,
    y: 415.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -29.4889 800.3799)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 427.7,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -35.4533 818.2556)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 424.4,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -31.7103 815.9456)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 434,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -34.5051 831.8315)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.6,
    y: 438.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -39.3752 834.8765)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 462.9,
    y: 426.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -17.9797 835.6945)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 418.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -9.3618 830.3258)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 470.7,
    y: 436.8,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -21.7905 852.2335)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.3,
    y: 431.2,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -15.6281 848.3914)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 480.4,
    y: 434.2,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -11.0385 859.6947)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.2,
    y: 427.6,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -3.6476 855.0801)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 488.9,
    y: 439.4,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -8.8602 872.4969)",
    className: "st20",
    width: 29.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.7,
    y: 445.9,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -16.1495 877.074)",
    className: "st4",
    width: 13.9,
    height: 4.1
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 321.1,
    y: 424.3,
    transform: "matrix(0.1513 -0.9885 0.9885 0.1513 -184.0792 711.5052)",
    className: "st16",
    width: 2.4,
    height: 77.3
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M327.9,511.1h289.2c8.8,0,15.9,7.1,15.9,15.9v86.2c0,8.8-7.1,15.9-15.9,15.9H327.9 c-8.8,0-15.9-7.1-15.9-15.9v-86.2C312,518.3,319.1,511.1,327.9,511.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage);
export default __webpack_public_path__ + "static/media/advantage.b23c5be5fcfeb06077c516b9be05c090.svg";
export { ForwardRef as ReactComponent };